/* ============================================================
   MẶC — phần dùng chung cho mọi trang
   Hai ngôn ngữ, giỏ hàng, con trỏ, thông báo nhỏ.
   ============================================================ */
(function () {
  'use strict';
  var MAC = window.MAC;

  /* ---------- ngôn ngữ ---------- */
  var CHU = {
    tieu_de:      ['Mặc Thử Cả Bộ.', 'Try the Look.'],
    dan:          ['Mười bộ đồ, phối sẵn từ đầu tới chân. Chạm vào chấm tròn để xem từng món.',
                   'Ten outfits, styled top to toe. Tap a dot to see each piece.'],
    nav_look:     ['Look', 'Looks'],
    nav_sp:       ['Sản phẩm', 'Shop'],
    gio:          ['Giỏ', 'Bag'],
    xem:          ['XEM', 'VIEW'],
    goi_y:        ['Chạm vào chấm để xem từng món', 'Tap a dot to shop the piece'],
    mua_ca_bo:    ['Mua cả bộ', 'Complete the look'],
    mua_phu:      ['{n} món, thêm vào giỏ một lần', 'All {n} pieces in one tap'],
    them_ca_bo:   ['Thêm cả bộ vào giỏ', 'Add full look to bag'],
    size:         ['Size', 'Size'],
    chon_size:    ['Chọn size trước nhé.', 'Pick a size first.'],
    da_them:      ['Đã thêm vào giỏ', 'Added to bag'],
    da_them_n:    ['Đã thêm {n} món vào giỏ', '{n} pieces added to bag'],
    gio_trong:    ['Giỏ đang trống.', 'Your bag is empty.'],
    tam_tinh:     ['Tạm tính', 'Subtotal'],
    thanh_toan:   ['Thanh toán', 'Checkout'],
    ghi_tt:       ['Bản xem thử: nút này sẽ nối vào cổng thanh toán Shopify khi lên cửa hàng thật.',
                   'Preview: this connects to Shopify checkout on the live store.'],
    ghi_tt_that:  ['Phí ship và mã giảm giá được tính ở bước thanh toán.',
                   'Shipping and discount codes are applied at checkout.'],
    the_paypal:   ['Nhận thẻ Visa, Mastercard qua PayPal, không cần tài khoản PayPal.',
                   'Visa and Mastercard accepted through PayPal, no PayPal account needed.'],
    ban_thu:      ['Bản xem thử · Giỏ hàng chưa nối cửa hàng', 'Preview · Bag not connected to the store'],
    gio_tieu_de:  ['Giỏ Hàng.', 'Your Bag.'],
    het_hang:     ['Tạm hết hàng', 'Sold out'],
    het_size:     ['{ten} size {s} đang tạm hết.', '{ten} in size {s} is sold out.'],
    loi_gio:      ['Chưa thêm được, bạn thử lại nhé.', 'Couldn’t add that. Please try again.'],
    dong:         ['Đóng', 'Close'],
    bo:           ['Bỏ', 'Remove'],
    truoc:        ['Look trước', 'Previous look'],
    sau:          ['Look sau', 'Next look'],
    tat_ca:       ['Tất cả', 'All'],
    sp_tieu_de:   ['Sản Phẩm.', 'Shop.'],
    xuong_sp:     ['Xem sản phẩm', 'Shop all'],
    ht_tieu_de:   ['Đổi Trả & Hoàn Hàng', 'Exchanges & Returns'],
    sp_dan:       ['{n} món lụa, phối thành mười bộ ở trang Look.', '{n} silk pieces, styled into ten looks.'],
    phoi_cung:    ['Phối cùng', 'Wear it with'],
    trong_look:   ['Có trong look', 'Seen in'],
    mau:          ['Màu', 'Colour'],
    chat_lieu:    ['Chất liệu', 'Fabric'],
    lua:          ['Lụa', 'Silk'],
    may:          ['Cắt may', 'Made'],
    may_v:        ['Tại xưởng Mặc, Việt Nam', 'In the Mặc workshop, Vietnam'],
    doi:          ['Đổi trả', 'Exchanges'],
    doi_v:        ['Đổi size trong 7 ngày', 'Size exchange within 7 days'],
    them_gio:     ['Thêm vào giỏ', 'Add to bag'],
    xem_ca_bo:    ['Xem cả bộ', 'See the full look'],
    giam:         ['Bớt {n}%', '{n}% off'],
    xem_look:     ['Xem look {so} {ten}', 'View look {so} {ten}'],
    xem_mon:      ['Món {so}: {ten}', 'Piece {so}: {ten}'],
    them_mon:     ['Thêm {ten} vào giỏ', 'Add {ten} to bag'],
    so_luong:     ['Số lượng', 'Quantity'],
    bot:          ['Bớt một', 'One fewer'],
    them_mot:     ['Thêm một', 'One more']
  };

  var NN = (function () { try { return localStorage.getItem('mac-nn') === 'en' ? 1 : 0; } catch (e) { return 0; } })();
  function t(khoa, bien) {
    var s = (CHU[khoa] || [khoa, khoa])[NN];
    if (bien) for (var k in bien) s = s.split('{' + k + '}').join(bien[k]);
    return s;
  }
  function chon(cap) { return Array.isArray(cap) ? cap[NN] : cap; }

  function datNgonNgu(i) {
    NN = i;
    try { localStorage.setItem('mac-nn', i ? 'en' : 'vi'); } catch (e) {}
    document.documentElement.lang = i ? 'en' : 'vi';
    document.querySelectorAll('[data-t]').forEach(function (el) { el.textContent = t(el.getAttribute('data-t')); });
    document.querySelectorAll('.ngon-ngu button').forEach(function (b) {
      b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-nn')) === i));
    });
    document.dispatchEvent(new CustomEvent('mac:ngonngu'));
    veGio();
  }

  /* ---------- tiền và ảnh ---------- */
  function tien(n) { return n.toLocaleString('vi-VN').replace(/,/g, '.') + '₫'; }
  /* Đường dẫn ảnh và trang, gom một chỗ để cùng một bộ mã chạy được ở hai nơi:
     - bản xem thử trên máy: ảnh nằm trong thư mục con, trang là tệp .html
     - theme Shopify: ảnh nằm phẳng trong assets và có địa chỉ CDN riêng
       (window.MAC_CDN), trang là /pages/san-pham (window.MAC_TRANG)
     Shopify không cho thư mục con trong assets nên tên tệp phải khác nhau. */
  var CDN = window.MAC_CDN || '';
  var TRANG = window.MAC_TRANG || { home: 'index.html', sp: 'san-pham.html', ct: 'chi-tiet.html' };
  function anhNguoi(n, co) {
    co = co || 1600;
    return CDN ? CDN + 'nguoi-' + n + '-' + co + '.webp' : 'assets/nguoi/' + n + '-' + co + '.webp';
  }
  function anhMon(id) { return CDN ? CDN + 'mon-' + id + '.webp' : 'assets/mon/' + id + '.webp'; }
  function duongHome() { return TRANG.home; }
  function duongSP() { return TRANG.sp; }
  function duongLook(so) { return TRANG.home + '?look=' + so; }
  function giaHtml(m) {
    return (m.giaGoc && m.giaGoc > m.gia ? '<s>' + tien(m.giaGoc) + '</s>' : '') + tien(m.gia);
  }

  /* ---------- sản phẩm thật trên Shopify ----------
     Trên theme Shopify, layout đặt window.MAC_SP theo handle sản phẩm:
       { u: đường dẫn, b: [[id biến thể, [giá trị phân loại], còn hàng 1/0, giá, giá gốc], ...] }
     lấy thẳng từ cửa hàng mỗi lần dựng trang. Mỗi món trong du-lieu.js là một màu
     (m.mau[0]) của một sản phẩm (m.sp, mặc định trùng id). Giá, giá gốc và còn hàng
     của Shopify đè lên số trong du-lieu.js. Không có MAC_SP là đang chạy bản xem thử. */
  var SP = window.MAC_SP || null;
  var bienThe = {};   // 'món|size' -> { id: id biến thể, con: còn hàng }
  var monCua = {};    // id biến thể -> [món, size]
  if (SP) Object.keys(MAC.mon).forEach(function (id) {
    var m = MAC.mon[id], p = SP[m.sp || id];
    m.het = true;
    if (!p) return;
    m.url = p.u;
    p.b.forEach(function (v) {
      // sản phẩm nhiều màu: chỉ lấy biến thể đúng màu của món này
      if (v[1].length > 1 && v[1].indexOf(m.mau[0]) < 0) return;
      ['S', 'M', 'L'].forEach(function (s) {
        if (v[1].indexOf(s) < 0) return;
        bienThe[id + '|' + s] = { id: v[0], con: !!v[2] };
        monCua[v[0]] = [id, s];
        if (!m.bt) m.bt = v[0];
        if (v[2]) m.het = false;
        m.gia = v[3];
        m.giaGoc = v[4] > v[3] ? v[4] : 0;
      });
    });
  });
  function conHang(id, s) {
    if (!SP) return true;
    var b = bienThe[id + '|' + s];
    return !!(b && b.con);
  }
  // trang sản phẩm Shopify (/products/handle?variant=...) đang hiện món nào
  function monTuSP(handle, idBT) {
    if (monCua[idBT]) return monCua[idBT][0];
    return Object.keys(MAC.mon).filter(function (id) { return (MAC.mon[id].sp || id) === handle; })[0];
  }
  function duongCT(id) {
    var m = MAC.mon[id];
    if (m.url) return m.url + (m.sp ? '?variant=' + m.bt : '');
    return TRANG.ct + '?mon=' + encodeURIComponent(id);
  }

  /* ---------- giỏ hàng ----------
     Bản xem thử: lưu trong trình duyệt. Trên Shopify: giỏ thật của cửa hàng qua
     /cart/add.js, /cart/change.js và /cart.js; nút thanh toán sang /checkout.
     Shopify trả số tiền theo đơn vị nhỏ nhất (x100), nên chia 100. */
  var GOC = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var gio = SP ? [] : (function () { try { return JSON.parse(localStorage.getItem('mac-gio') || '[]'); } catch (e) { return []; } })();
  var gioThat = null;
  function luuGio() { try { localStorage.setItem('mac-gio', JSON.stringify(gio)); } catch (e) {} }

  function goi(duong, du) {
    return fetch(GOC + duong, {
      method: du ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: du ? JSON.stringify(du) : undefined
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function taiGio() { return goi('cart.js').then(function (c) { gioThat = c; veGio(); return c; }); }

  // các dòng trong giỏ, cùng một dạng cho cả hai nơi
  function hangGio() {
    if (!SP) return gio.map(function (x, i) {
      var m = MAC.mon[x.id];
      return { khoa: i, sl: x.sl, anh: anhMon(x.id), ten: chon(m.ten), phu: chon(m.mau) + ' · Size ' + x.size, tien: m.gia * x.sl };
    });
    return (gioThat ? gioThat.items : []).map(function (x) {
      var mc = monCua[x.variant_id], m = mc && MAC.mon[mc[0]];
      return { khoa: x.key, sl: x.quantity, tien: x.final_line_price / 100,
        anh: m ? anhMon(mc[0]) : (x.image || ''), ten: m ? chon(m.ten) : x.product_title,
        phu: m ? chon(m.mau) + ' · Size ' + mc[1] : (x.variant_title || '') };
    });
  }
  function soMon() {
    if (SP) return gioThat ? gioThat.item_count : 0;
    return gio.reduce(function (a, x) { return a + x.sl; }, 0);
  }
  function tongGio() {
    if (SP) return gioThat ? gioThat.total_price / 100 : 0;
    return gio.reduce(function (a, x) { return a + MAC.mon[x.id].gia * x.sl; }, 0);
  }

  /* ds: [{ id: món, size, sl }]. Thêm một lần cho cả danh sách (nút "Thêm cả bộ"
     gửi một yêu cầu, không gửi từng món kẻo chồng lên nhau). Trả về Promise<true|false>;
     thêm được thì hiện chuBao, không được thì tự báo lý do. */
  function themGio(ds, chuBao) {
    if (!SP) {
      ds.forEach(function (x) {
        var co = gio.find(function (g) { return g.id === x.id && g.size === x.size; });
        if (co) co.sl += x.sl || 1; else gio.push({ id: x.id, size: x.size, sl: x.sl || 1 });
      });
      luuGio(); veGio();
      if (chuBao) bao(chuBao);
      return Promise.resolve(true);
    }
    var het = ds.filter(function (x) { return !conHang(x.id, x.size); })[0];
    if (het) {
      bao(t('het_size', { ten: chon(MAC.mon[het.id].ten), s: het.size }));
      return Promise.resolve(false);
    }
    return goi('cart/add.js', { items: ds.map(function (x) { return { id: bienThe[x.id + '|' + x.size].id, quantity: x.sl || 1 }; }) })
      .then(taiGio)
      .then(function () { if (chuBao) bao(chuBao); return true; })
      .catch(function (e) { bao((e && e.description) || t('loi_gio')); return false; });
  }

  function doiSoLuong(khoa, sl) {
    if (!SP) {
      var i = Number(khoa);
      if (sl < 1) gio.splice(i, 1); else gio[i].sl = sl;
      luuGio(); veGio();
      return;
    }
    goi('cart/change.js', { id: khoa, quantity: Math.max(0, sl) })
      .then(function (c) { gioThat = c; veGio(); })
      .catch(function (e) { bao((e && e.description) || t('loi_gio')); taiGio(); });
  }

  function veGio() {
    document.querySelectorAll('.so-gio').forEach(function (el) { el.textContent = '(' + soMon() + ')'; });
    var ds = document.getElementById('gioDs');
    if (!ds) return;
    var hang = hangGio();
    if (!hang.length) {
      ds.innerHTML = '<p class="gio-trong">' + t('gio_trong') + '</p>';
    } else {
      ds.innerHTML = hang.map(function (x) {
        var k = ' data-k="' + x.khoa + '" data-sl="' + x.sl + '"';
        return '<div class="gm">' +
          '<div class="mon-anh"><img src="' + x.anh + '" alt="" loading="lazy"></div>' +
          '<div><p class="gm-ten">' + x.ten + '</p>' +
          '<p class="gm-phu">' + x.phu + '</p>' +
          '<div class="gm-sl" role="group" aria-label="' + t('so_luong') + '">' +
            '<button type="button" data-gio="bot"' + k + ' aria-label="' + t('bot') + '">−</button>' +
            '<span>' + x.sl + '</span>' +
            '<button type="button" data-gio="them"' + k + ' aria-label="' + t('them_mot') + '">+</button></div></div>' +
          '<div class="gm-phai"><p class="mon-gia">' + tien(x.tien) + '</p>' +
          '<button type="button" class="gm-bo" data-gio="bo"' + k + '>' + t('bo') + '</button></div></div>';
      }).join('');
    }
    var el = document.getElementById('gioTong');
    if (el) el.textContent = tien(tongGio());
    var tt = document.getElementById('gioTT');
    if (tt && SP) tt.setAttribute('aria-disabled', String(!hang.length));
  }

  function moGio() {
    if (document.getElementById('gio').classList.contains('tinh')) return;
    document.getElementById('gio').classList.add('hien');
    document.getElementById('man').classList.add('hien');
    document.getElementById('gio').setAttribute('aria-hidden', 'false');
    setTimeout(function () { var b = document.querySelector('#gio .dong-bang'); if (b) b.focus(); }, 80);
  }
  function dongGio() {
    document.getElementById('gio').classList.remove('hien');
    document.getElementById('man').classList.remove('hien');
    document.getElementById('gio').setAttribute('aria-hidden', 'true');
  }

  var hen;
  function bao(chu) {
    var el = document.getElementById('bao');
    el.textContent = chu;
    el.classList.add('hien');
    clearTimeout(hen);
    hen = setTimeout(function () { el.classList.remove('hien'); }, 1900);
  }

  /* ---------- con trỏ: chấm đen theo chuột, có độ trễ nhẹ ---------- */
  function dungConTro() {
    if (!matchMedia('(hover:hover) and (pointer:fine)').matches) return null;
    if (matchMedia('(prefers-reduced-motion:reduce)').matches) return null;
    var el = document.createElement('div');
    el.className = 'con-tro';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<i><b>' + t('xem') + '</b></i>';
    document.body.appendChild(el);
    document.body.classList.add('co-con-tro');
    var mx = innerWidth / 2, my = innerHeight / 2, x = mx, y = my, chay = false, last = 0;
    function buoc(now) {
      var dt = Math.min(48, now - (last || now)); last = now;
      var k = 1 - Math.pow(1 - 0.28, dt / 16.67);
      x += (mx - x) * k; y += (my - y) * k;
      el.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      if (Math.abs(mx - x) + Math.abs(my - y) > 0.3) requestAnimationFrame(buoc); else { chay = false; last = 0; }
    }
    addEventListener('pointermove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!chay) { chay = true; requestAnimationFrame(buoc); }
    }, { passive: true });
    document.addEventListener('mac:ngonngu', function () { el.querySelector('b').textContent = t('xem'); });
    return {
      dat: function (trangThai) { el.className = 'con-tro' + (trangThai ? ' ' + trangThai : ''); }
    };
  }

  /* ---------- gắn sự kiện chung ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nn]');
    if (b) { datNgonNgu(Number(b.getAttribute('data-nn'))); return; }
    if (e.target.closest('[data-mo-gio]')) { e.preventDefault(); moGio(); return; }
    if (e.target.closest('[data-dong-gio]') || e.target.id === 'man') { dongGio(); return; }
    var g = e.target.closest('[data-gio]');
    if (g) {
      var hd = g.getAttribute('data-gio'), sl = Number(g.getAttribute('data-sl'));
      doiSoLuong(g.getAttribute('data-k'), hd === 'them' ? sl + 1 : hd === 'bot' ? sl - 1 : 0);
    }
  });
  addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.getElementById('gio').classList.contains('hien')) dongGio();
  });

  /* ---------- phần khung dùng chung: thanh trên cùng, giỏ, thông báo ----------
     Viết một lần ở đây cho cả ba trang, thay vì chép vào từng tệp HTML. */
  function veKhung(trang) {
    var dau = document.createElement('header');
    dau.className = 'dau';
    dau.innerHTML =
      '<a class="logo" href="' + duongHome() + '" aria-label="Mặc"><span class="logo-m" aria-hidden="true">M</span></a>' +
      '<nav class="dau-phai" aria-label="Chính">' +
        '<a href="' + duongHome() + '"' + (trang === 'look' ? ' aria-current="page"' : '') + ' class="dau-an-hep" data-t="nav_look"></a>' +
        '<a href="' + duongSP() + '"' + (trang === 'sp' ? ' aria-current="page"' : '') + ' data-t="nav_sp"></a>' +
        '<span class="ngon-ngu" role="group" aria-label="Ngôn ngữ / Language">' +
          '<button type="button" data-nn="0" aria-pressed="true">VN</button><span>/</span>' +
          '<button type="button" data-nn="1" aria-pressed="false">EN</button></span>' +
        '<button type="button" data-mo-gio><span data-t="gio"></span>&nbsp;<span class="so-gio">(0)</span></button>' +
      '</nav>';
    document.body.insertBefore(dau, document.body.firstChild);

    var cuoi = document.createElement('div');
    cuoi.innerHTML =
      '<div class="man" id="man"></div>' +
      '<aside class="gio" id="gio" aria-hidden="true" aria-labelledby="gioTieuDe">' +
        '<div class="gio-dau"><p id="gioTieuDe"><span data-t="gio"></span> <span class="so-gio">(0)</span></p>' +
          '<button type="button" class="dong-bang" data-dong-gio aria-label="Đóng">&#215;</button></div>' +
        '<div class="gio-ds" id="gioDs"></div>' +
        '<div class="gio-chan"><div class="tong"><p data-t="tam_tinh"></p><p class="tong-gia" id="gioTong">0₫</p></div>' +
          // trên Shopify là đường dẫn thật sang trang thanh toán của Shopify
          (SP ? '<a class="nut" id="gioTT" href="/checkout" aria-disabled="true">'
              : '<button type="button" class="nut">') +
            '<span data-t="thanh_toan"></span><span class="mui-ngang" aria-hidden="true">&#8594;</span>' +
          (SP ? '</a>' : '</button>') +
          // tắt PayPal trong Shopify thì phải bỏ dòng the_paypal, kẻo báo sai với khách
          (SP ? '<p class="ghi" data-t="the_paypal"></p>' : '') +
          '<p class="ghi" data-t="' + (SP ? 'ghi_tt_that' : 'ghi_tt') + '"></p></div>' +
      '</aside>' +
      '<div class="bao" id="bao" role="status" aria-live="polite"></div>' +
      (SP ? '' : '<p class="ban-thu" data-t="ban_thu"></p>');
    while (cuoi.firstChild) document.body.appendChild(cuoi.firstChild);

    // trang /cart của Shopify: giỏ nằm yên giữa trang thay vì trượt ra
    var vungGio = trang === 'gio' && document.querySelector('[data-trang="gio"]');
    if (vungGio) {
      var g = document.getElementById('gio');
      g.classList.add('tinh');
      g.setAttribute('aria-hidden', 'false');
      vungGio.appendChild(g);
    }

    // liên kết tới trang đổi trả, ở cuối phần nội dung; trang này chỉ có trên Shopify
    var vungCuoi = document.querySelector('.trang');
    if (SP && vungCuoi && trang !== 'doi-tra') {
      vungCuoi.insertAdjacentHTML('beforeend', '<p class="chan-trang"><a href="/pages/doi-tra" data-t="ht_tieu_de"></a></p>');
    }
  }

  window.MACUI = {
    t: t, chon: chon, tien: tien, giaHtml: giaHtml, anhNguoi: anhNguoi, anhMon: anhMon,
    duongCT: duongCT, duongLook: duongLook, duongSP: duongSP,
    themGio: themGio, conHang: conHang, monTuSP: monTuSP,
    moGio: moGio, bao: bao, nn: function () { return NN; },
    conTro: null, khoiDong: function (trang) {
      veKhung(trang);
      this.conTro = dungConTro();
      datNgonNgu(NN);
      // thanh trên cùng có nền khi đã cuộn, để chữ không đè lên ảnh sản phẩm
      var dau = document.querySelector('.dau');
      function nenDau() { dau.classList.toggle('co-nen', scrollY > 8); }
      addEventListener('scroll', nenDau, { passive: true });
      nenDau();
      if (SP) {
        taiGio();
        // quay lại từ trang thanh toán bằng nút Back: trình duyệt lấy trang cũ trong bộ nhớ, giỏ có thể đã khác
        addEventListener('pageshow', function (e) { if (e.persisted) taiGio(); });
      }
    }
  };

  /* Tự khởi động. Các tệp mã được nạp với defer nên chạy theo thứ tự sau khi
     trang dựng xong; khởi động ngay ở đây thì look.js và cua-hang.js chạy sau
     sẽ có sẵn thanh trên cùng, giỏ hàng và con trỏ. Không gọi từ một thẻ
     script viết thẳng trong HTML, vì thẻ đó chạy trước khi tệp này kịp tải. */
  var vung = document.querySelector('[data-trang]');
  window.MACUI.khoiDong(vung ? vung.getAttribute('data-trang') : '');
})();
